module.exports = __webpack_public_path__ + "product-compound-capsule-07.jpg?f8dbe16d4eec28c1ed628273817af1ec";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-07.jpg
// module id = 104
// module chunks = 0